import styled from 'styled-components';

export const Title = styled.div`
  padding: 20px;
  font-weight: 700;
  font-size: 16px;
  line-height: 13px;
  border-bottom: 1px solid #e0e7eb;
`;
export const Content = styled.div`
  padding: 28px 25px 30px;
  width: 500px;
  max-width: 540px;
`;
const Wrapper = styled.div`
  overflow-y: auto;

  border-radius: 4px;
  position: relative;
  pointer-events: all;
  max-height: calc(100vh - 40px);
  background: #fff;
`;

export default Wrapper;
